import React from 'react';
import {
  TextField,
  Button,
  Stack,
  MenuItem,
  InputAdornment,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { buildClientPolicySavePayload } from '../../utils/settingsForm';
import { DEFAULT_RESERVATION_LIMIT } from '../../constants/appConstants';
import { getCurrencySymbol } from '../../utils/currency';

export default function ClientPolicySettingsPanel({
  form,
  setField,
  onSave,
  onReset,
  saving,
}) {
  const { t } = useTranslation();
  const currencySymbol = getCurrencySymbol(form.checkCurrency);

  const handleSave = () => {
    onSave(buildClientPolicySavePayload(form));
  };

  return (
    <Stack spacing={2.5}>
      <TextField
        label={t('settings.maxReservationAmount')}
        value={form.maxReservationAmount}
        onChange={(e) => setField('maxReservationAmount', e.target.value)}
        type="number"
        inputProps={{ min: 0, step: 100 }}
        InputProps={{ startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment> }}
        placeholder={t('settings.reservationAmountPlaceholder', { amount: DEFAULT_RESERVATION_LIMIT.toLocaleString() })}
        helperText={t('settings.reservationAmountHelp', { currency: currencySymbol, amount: DEFAULT_RESERVATION_LIMIT.toLocaleString() })}
        size="small"
        sx={{ maxWidth: 280 }}
      />
      <TextField
        label={t('settings.maxDiscountPercent')}
        value={form.maxDiscountPercent}
        onChange={(e) => setField('maxDiscountPercent', e.target.value)}
        type="number"
        inputProps={{ min: 0, max: 100, step: 1 }}
        helperText={t('settings.maxDiscountPercentHelp')}
        size="small"
        sx={{ maxWidth: 280 }}
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <TextField
          select
          label={t('settings.defaultReservationMode')}
          value={form.reservationMode}
          onChange={(e) => setField('reservationMode', e.target.value)}
          size="small"
          sx={{ minWidth: 220 }}
        >
          <MenuItem value="request">{t('settings.reservationModeRequest')}</MenuItem>
          <MenuItem value="auto">{t('settings.reservationModeAuto')}</MenuItem>
        </TextField>
        <TextField
          label={t('settings.defaultReservationDuration')}
          value={form.defaultReservationDuration}
          onChange={(e) => setField('defaultReservationDuration', e.target.value)}
          type="number"
          inputProps={{ min: 1 }}
          size="small"
          sx={{ maxWidth: 180 }}
        />
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? t('common.saving') : t('common.save')}
        </Button>
        <Button variant="outlined" onClick={onReset} disabled={saving}>{t('common.reset')}</Button>
      </Stack>
    </Stack>
  );
}
